import React, { useEffect, useMemo, useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import { Plus, Edit, Trash2, Search, X, Image as ImageIcon } from 'lucide-react';
import './SubCategories.css';
import Cookies from 'js-cookie';
import { handleGetApi, handlePostApi } from '../../api/api';

const SubCategories = () => {
 const token = JSON.parse(Cookies.get('auth_token'));
  const headers = {
    Authorization: token
  }
  const [subCategories, setSubCategories] = useState([]);
 
const [categories, setCategories] = useState([]);
  const [search,setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingSub, setEditingSub] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    category_id: '',
    slug: '',
    image: '',
    description: '',
  });
const fetchCategory = async () => {
    const res = await handleGetApi('admin/get/category', headers)
    setCategories(res.data)
  }
  const fetchSubCategory = async () => {
    const res = await handleGetApi('admin/get/subCategory', headers)
    setSubCategories(res.data)
  }
  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
  }, [])
  const handleOpenModal = (sub = null) => {
    if (sub) {
      setEditingSub(sub);
      setFormData({
        name: sub.name || '',
        category_id: sub.category_id || '',
        slug: sub.slug || '',
        image: sub.image || '',
        description: sub.description || '',
      });
    } else {
      setEditingSub(null);
      setFormData({
        name: '',
        category_id: '',
        slug: '',
        image: '',
        description: '',
      });
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingSub(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const sendData = new FormData();
    sendData.append('name', formData.name);
    sendData.append('slug', formData.slug);
    sendData.append('description', formData.description);
    sendData.append('category_id', formData.category_id);
    
    if (formData.image instanceof File) {
      sendData.append('subCategory', formData.image);
    }

    const name = categories.find(k => k?.id == formData?.category_id);
    if (editingSub) {
      sendData.append('id', editingSub.id);
      const res = await handlePostApi(`admin/update/subCategory`, sendData, headers);
      const newImage = res?.image ? res?.image : formData.image;
      setSubCategories(subCategories.map(s => s.id === editingSub.id ? { 
        ...formData, 
        id: s.id, 
        image: newImage,
        category_name: name?.name 
      } : s));
    } else {
      const res = await handlePostApi(`admin/add/subCategory`, sendData, headers);
      const newImage = res?.image;
      setSubCategories([...subCategories, { 
        ...formData, 
        id: res?.insertId, 
        image: newImage,
        category_name: name?.name 
      }]);
    }
    handleCloseModal();
  };
  console.log(formData,'formdata')
 const filteredSubCategories = useMemo(() => {
    if (!search.trim()) return subCategories;
    return subCategories.filter(item => item?.name.toLowerCase().includes(search.toLocaleLowerCase()))
  }, [subCategories, search])
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this sub-category?')) {
      const res = await handlePostApi('admin/delete/subCategory', { id }, headers);
      setSubCategories(subCategories.filter(s => s.id !== id));
    }
  };

  return (
    <MainLayout title="Sub Category Management">
      <div className="sub-categories-container fade-in">
        <div className="sub-header">
          <div className="search-filters">
            <div className="search-input">
              <Search size={18} />
              <input type="text" value={search} onChange={(e)=>{setSearch(e.target.value)}} placeholder="Search sub-categories..." />
            </div>
          </div>
          <button className="add-btn" onClick={() => handleOpenModal()}>
            <Plus size={20} />
            <span>Add Sub Category</span>
          </button>
        </div>

        <div className="sub-card">
          <div className="table-responsive">
            <table className="sub-table">
              <thead>
                <tr>
                  <th>Sub Category</th>
                  <th>Parent Category</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {subCategories && filteredSubCategories.map((sub) => (
                  <tr key={sub.id}>
                    <td className="sub-cell">
                      <div className="sub-img-wrapper">
                        {sub?.image ? (
                          <img 
                            src={
                              typeof sub.image === 'string' && sub.image.startsWith('blob:')
                                ? sub.image
                                : `${process.env.REACT_APP_IMAGE_URL}subCategory/${sub.image}`
                            } 
                            alt={sub.name} 
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <ImageIcon size={20} className="text-muted" />
                        )}
                      </div>
                      <span className="sub-name">{sub.name}</span>
                    </td>
                    <td><span className="parent-cat-tag">{sub.category_name}</span></td>
                    
                    <td>
                      <div className="action-btns">
                        <button className="edit-btn" onClick={() => handleOpenModal(sub)}>
                          <Edit size={18} />
                        </button>
                        <button className="delete-btn" onClick={() => handleDelete(sub.id)}>
                          <Trash2 size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content fade-in">
            <div className="modal-header">
              <h2>{editingSub ? 'Edit Sub Category' : 'Add New Sub Category'}</h2>
              <button className="close-modal" onClick={handleCloseModal}><X size={24} /></button>
            </div>
            <form onSubmit={handleSubmit} className="sub-form">
              <div className="form-group">
                <label>Sub Category Image</label>
                <div className="image-upload-wrapper">
                  {formData.image ? (
                    <div className="preview-container">
                      <img
                        src={
                          typeof formData.image === 'string'
                            ? (formData.image.startsWith('blob:') ? formData.image : `${process.env.REACT_APP_IMAGE_URL}subCategory/${formData.image}`)
                            : URL.createObjectURL(formData.image)
                        }
                        alt="Sub Category Preview"
                      />
                      <button
                        type="button"
                        className="remove-img"
                        onClick={() => setFormData({ ...formData, image: '' })}
                        title="Remove Image"
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ) : (
                    <label htmlFor="subcategory-image-input" className="upload-box">
                      <ImageIcon size={24} />
                      <span>Upload Image</span>
                      <input
                        type="file"
                        id="subcategory-image-input"
                        hidden
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({ ...formData, image: file });
                          }
                        }}
                      />
                    </label>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>Sub Category Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g. Sofas"
                  required
                />
              </div>
              <div className="form-group">
                <label>Parent Category</label>
                <select
                  value={formData.category_id}
                  onChange={(e) => setFormData({ ...formData, category_id: e.target.value })}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Sub Category Slug</label>
                <input
                  type="text"
                  value={formData.slug}
                  onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
                  placeholder="e.g. Sofas"
                  required
                />
              </div>
               <div className="form-group">
                <label>Sub Category description</label>
                <input
                  type="text"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  placeholder="description"
                  required
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={handleCloseModal}>Cancel</button>
                <button type="submit" className="save-btn">{editingSub ? 'Update' : 'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default SubCategories;
